<template>
  <section class="row">
    <div class="col-12 col-md-9 mx-auto">
      <v-select
        input-id="contract-insurer"
        label="Nombre de salarié en télétravail"
        placeholder=""
        module-name="contract"
        getter-name="get"
        :getter-function="({ risk: { employeesBracket } }) => employeesBracket.code"
        setter-name="updateSubscription"
        :path="`risk.employeesBracket`"
        :list="adapterEmployeesBrackets"
        class="my-2"
      />
    </div>
  </section>
</template>
<script>
import { mapGetters } from 'vuex';

import Select from '@/components/common/input/CustomSelect2.vue';

export default {
  components: {
    'v-select': Select,
  },
  computed: {
    ...mapGetters({ employeesBrackets: 'rater/employeesBrackets' }),
    adapterEmployeesBrackets() {
      return this.employeesBrackets
        .map(({ code, min, max }) => ({ code, name: `${min} à ${max}` }));
    },
  },
};
</script>
